import {
  PORTAL_LINK_BASE_PATH,
  PORTAL_LINK_SHIPMENTS_PATH,
} from 'rate-command-center/ui/PortalLinkRoute'

import { PORTAL_BASE_PATH } from '../../core/ui/PortalRoute'

const PORTAL_SHIPMENTS_PATH = `${PORTAL_BASE_PATH}/shipments`

/**
 * Resolves the shipments-list path to navigate back to, keeping magic-link
 * visitors inside the `/portal-link` flow (where the logged-in `/portal`
 * routes would bounce them to login).
 */
export function resolveShipmentsListPath(pathname: string): string {
  return pathname.includes(PORTAL_LINK_BASE_PATH)
    ? PORTAL_LINK_SHIPMENTS_PATH
    : PORTAL_SHIPMENTS_PATH
}
